module.exports = __webpack_public_path__ + "static/media/icone-acoes.bbc654dc.png";